import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { TXTWCL_There_are_a_variety_of_self_ex_ELL } from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <Translation
    values={{
      a: (msg: React.ReactNode) => (
        <ResolverLink resolverTag={ResolverTag.HelpSelfExcludedAccount}>{msg}</ResolverLink>
      )
    }}
    {...TXTWCL_There_are_a_variety_of_self_ex_ELL}
  />
);

export default HelpSectionContent;
